import { render, staticRenderFns } from "./BusinessTable.vue?vue&type=template&id=06901069"
import script from "./BusinessTable.vue?vue&type=script&lang=js"
export * from "./BusinessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports